import React, { useEffect, useState } from "react";
import { Flex, Text } from "@radix-ui/themes";
import { Button } from "../../ui/Button";
import _ from "lodash";
import { TbEdit, TbPlus, TbTrendingDown2 } from "react-icons/tb";
import { useTranslation } from "react-i18next";
import { NavLink, Outlet,  useNavigate } from "react-router-dom";
import RoleRequire from "../../helpers/auth/RoleRequire";
import { useAppStore } from "../../stores/RootStore";
import { ColumnDef } from "@tanstack/react-table";
import { DataTable } from "../../ui/DataTable/DataTable";
import { DivisionTableData } from "../../types/formDataTypes";
import { Separator } from "../../ui/Separator";
import { Input } from "../../ui/Input/Input";
import { useRefreshDivisions } from "../../hooks/useRefreshStateHooks/useRefreshDivisions";
import { MenuDataTable } from "../../ui/DataTable/MenuDataTable";
import { hexColor } from "../../enums/colors";

type Props = {
  onClose: Function;
};

export const DivisionsGrid = ({onClose}: Props) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [search, setSearch] = React.useState("");
  const divisions = useAppStore((state) => state.divisions);

  // Получение данных и обновление их в сторе.
  const updateItems = useRefreshDivisions();
  useEffect(() => {
    updateItems();
  }, []);


  let nodes = divisions?.map((division) => {
    return {
      id: division.id,
      parent_id: division.attributes.parent_id,
      name: division.attributes.name,
      parent_name: division.attributes.parent_id ? divisions.find(d => d.id === String(division.attributes.parent_id))?.attributes.name : "",
      depth: division.attributes.depth,
      personnels_count: division.attributes.personnels_count,
      accepted_personnels_count: division.attributes.accepted_personnels_count,
      fired_personnels_count: division.attributes.fired_personnels_count,
      transferred_personnels_count: division.attributes.transferred_personnels_count,
      vacation_personnels_count: division.attributes.vacation_personnels_count,
      equipment_items_count: division.attributes.equipment_items_count,
    };
  });

  nodes = _.sortBy(nodes, []);
  let data = { nodes };

  // // Преобразование данных для Expanding таблицы
  // let max_depth = 0;
  // for (let node of nodes) {
  //   if (node.depth > max_depth) {
  //     max_depth = node.depth;
  //   }
  // }

  // let nodesWithChildrens = nodes.map((node) => {
  //   return { ...node, ...{ childrens: new Array<string>(), subRows: new Array<any>() } };
  // });

  // for (let index = max_depth; index > 0; index--) {
  //   for (let node of nodesWithChildrens) {
  //     if (node.depth == index) {
  //       nodesWithChildrens.find((div) => div.id == String(node.parent_id))?.subRows?.push(node);
  //       nodesWithChildrens = nodesWithChildrens.filter((div) => !(div.id == node.id));
  //     }
  //   }
  // }

  // Сортировка по умолчанию

  const handleSearch = (event: any) => {
    setSearch(event.target.value);
  };

  // Фильтрация через поиск
  data = {
    nodes: data.nodes?.filter((item) => item.name.toLowerCase().includes(search.toLowerCase())),
  };
  

  const columns: ColumnDef<any>[] = [
    {
      id: "id",
      accessorKey: "id",
      header: t("title_name"),
      size: 1000,
      cell: (props) => 
      (
        <div className={`max-w-[420px] w-full flex`} style={{marginLeft: props.row.original.depth && props.row.original.depth > 1 ? props.row.original.depth * 10 : 0}}>
          {props.row.original.depth && props.row.original.depth > 0 ? <div className="flex w-4 h-4 bg-muted rounded items-center justify-center text-xs mr-1 mt-[1px]">{props.row.original.depth}</div> : <></>}
          <div>
            <div className="font-medium truncate flex items-center">
              {props.row.original.name}
            </div>
            <div className="truncate ">{`${props.row.original.parent_name}`}</div>
          </div>
        </div>
      ),
    },
    {
      header: t("division_persons"),
      cell: ({ row }) => (
        <div className="space-x-1">
          <span className="font-medium">{row.original.personnels_count}</span>
          <span className="font-medium">{t('humans')}</span>
        </div>
      ),
    },
    {
      accessorKey: "equipment_items_count",
      header: t("equipment"),
      cell: ({ row }) => (
        <div className="space-x-1">
          <span className="font-medium">{row.original.equipment_items_count}</span>
          <span className="font-medium">{t('equipment_units')}</span>
        </div>
      )
    },
  ];


  function selectDivision(equipment: any) {
    onClose()
  }

  function addDivision() {
    navigate("/data/divisions/new")
    onClose()
  }

  return (
    <>
        <div className="flex flex-col w-full">
            <div className="flex flex-row w-full h-14 items-center gap-4 px-6 justify-between">
                <Input 
                    className="h-8"
                    placeholder={t("divisions_search")}
                    onChange={handleSearch}
                    value={search}
                    autoComplete="off"
                    width="100%" 
                />
                
                <RoleRequire role="maintainer">
                    <Button variant={"default"} size={"md"} onClick={() => addDivision()}>{t("add")}</Button>
                </RoleRequire>
            </div>
            {/* <Filter filterState={[filter, setFilter]} categories={categories} /> */}
        </div>

        {!data.nodes?.length ? ( // Заглушка для отсутствия данных при поиске
        <div className="flex w-full h-full justify-center items-center">
            {t("no_data")}
        </div>
        ) : (
          <MenuDataTable route="/data/divisions" data={data.nodes} columns={columns} onClickRow={selectDivision}/>
        )}
    </>
  );
};
